__turbopack_context__.v({
  "tab_container": "GvLkYW_tab_container",
  "tab_panel": "GvLkYW_tab_panel",
  "tab_sections": "GvLkYW_tab_sections",
  "tabs": "GvLkYW_tabs",
});
